import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material';
import { ClaimLevel, EmployeeSearchResult } from '@akiba/models_bimbo';
import { AuthenticationService } from '../../../services/authentication.service';
import { DataSourceService } from '../../../services/data-source.service';
import { ActivatedRoute } from '@angular/router';
import { LogicService } from '../../../services/logic.service';
import { storage } from 'firebase';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeListComponent implements OnInit, OnDestroy {

  listener: Subscription;
  displayedColumns: string[] = ['employeeNumber', 'username', 'email', 'company', 'details'];
  dataSource: MatTableDataSource<EmployeeSearchResult>;
  readyToSearch = false;

  stateSearchBox: { query: string; refine: Function } = {
    query: '',
    refine() { }
  };

  stateToggle: { refine: Function } = {
    refine() { }
  };

  stateRefinement: { refine: Function } = {
    refine() { }
  };

  stateHits: { hits: {}[] } = { hits: [] };

  statePagination: { currentRefinement: number, nbPages: number, refine: Function } = {
    currentRefinement: 0,
    nbPages: 0,
    refine() { }
  };

  statePaginationRefine(page: number) {
    this.statePagination.refine(page);
  }

  get pages(): number[] {
    return Array.apply(null, { length: this.statePagination.nbPages }).map(Number.call, Number);
  }

  constructor(private ds: DataSourceService, private authService: AuthenticationService, public logicService: LogicService) {

    this.listener = this.authService.authUserSubject.subscribe((result) => {

      if (result) {
        this.readyToSearch = true;
        this.logicService.dataManager.proxyDataLoader.employee = null;
        this.logicService.dataManager.generalDataLoader.load();
        this.logicService.dataManager.parameterDataLoader.load();
      }

    });

  }

  ngOnInit() {

    localStorage.clear();
    if (this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation && this.logicService.dataManager.principalDataLoader.employee.workInformation.laidOff ) {
      this.authService.signOut();
      return;
    }
    
  }


  searchBoxState = (state, isFirstRendering) => {
    if (isFirstRendering) {
      return Promise.resolve(null).then(() => {
        this.stateSearchBox = state;
      });
    }
    this.stateSearchBox = state;
  }

  toggleState = (state, isFirstRendering) => {
    if (isFirstRendering) {
      return Promise.resolve(null).then(() => {
        this.stateToggle = state;
      });
    }
    this.stateToggle = state;
  }

  refinementState = (state, isFirstRendering) => {

    if (isFirstRendering) {
      return Promise.resolve(null).then(() => {
        this.stateRefinement = state;
      });
    }
    this.stateRefinement = state;
  }

  paginationState = (state, isFirstRendering) => {

    if (isFirstRendering) {
      return Promise.resolve(null).then(() => {
        this.statePagination = state;
      });
    }

    this.statePagination = state;

  }

  handleChange(searchString: string) {

    if (!searchString) {
      return null;
    }
//empleadosdev
    const query: any = {
      index: 'bimbo',
      query: searchString,
      restrictions: null,
      filter: false
    };

    if (this.authService.appLevel.currentClaim !== ClaimLevel.administrator && this.authService.appLevel.currentClaim !== ClaimLevel.akiba) {
      query.restrictions = { supervisor: this.authService.authEmployee.uid };
    }

    this.ds.search(query).then(result => {
      this.stateHits = result.hits;
      this.dataSource = new MatTableDataSource(this.stateHits.hits.map((hit: any) => new EmployeeSearchResult(hit._source)));
    }).catch(error => console.log(error));

  }

  ngOnDestroy(): void {
    this.logicService.dataManager.proxyDataLoader.employee = null;
    if (this.listener && !this.listener.closed) {
      this.listener.unsubscribe();
      this.listener = null;
    }
  }

}
